import React from 'react'
import { connect } from 'react-redux'
import { doGetTeam, doSaveTeam, doDelTeam } from '../../reducers/actions'

class TeamDiv extends React.Component {
  state = {
  }

  componentDidMount = () => {
    const { onClose, dispatch, id, depID } = this.props
    dispatch(doGetTeam({
      id,
      depID,
      onEnd: ({ errorMessage, initValues基本信息 }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else if (initValues基本信息) {
          this.setState({ id, depID, initValues基本信息, changedValues基本信息: {} })
        }
      }
    }))
  }

  handlerConfirm = () => {
    const { onSave, onClose, dispatch } = this.props
    const { id, depID, initValues基本信息, changedValues基本信息 } = this.state

    var newValues = changedValues基本信息
    if (id <= 0) {
      newValues = { '排序': initValues基本信息['排序'], ...changedValues基本信息 }
    }

    dispatch(doSaveTeam({
      id,
      depID,
      changedValues基本信息: newValues,
      onEnd: ({ errorMessage }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else {
          Ext.toast('保存成功')
          onSave && onSave()
          onClose && onClose()
        }
      }
    }))
  }

  handlerDelete = () => {
    const { id } = this.state
    const { onSave, onClose, dispatch } = this.props

    Tyan.pubForm.showConfirm('确定要删除？', () =>
      dispatch(doDelTeam({
        id,
        onEnd: ({ errorMessage }) => {
          if (errorMessage) {
            Tyan.pubForm.showError(errorMessage)
          }
          else {
            Ext.toast('删除成功')
            onSave && onSave()
            onClose && onClose()
          }
        }
      })))
  }

  handlerClose = () => {
    const { onClose } = this.props
    if (!this.bChanged()) {
      onClose && onClose()
      return
    }
    Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
  }


  canSave = () => {
    const { initValues基本信息, changedValues基本信息 } = this.state
    const values = { ...initValues基本信息, ...changedValues基本信息 }
    return this.bChanged() && values.小组名称
  }

  bChanged = () => {
    const { changedValues基本信息 } = this.state
    return Object.keys(changedValues基本信息).length > 0
  }


  fieldset基本信息 = () => {
    const { initValues基本信息, changedValues基本信息 } = this.state
    const values = { ...initValues基本信息, ...changedValues基本信息 }
    return [
      { _text: '部门', name: '部门', disabled: true },
      { _text: '小组名称', name: '小组名称', required: true },
      { _text: '描述', name: '描述', maxRows: 3 },
      { _number: '排序', name: '排序' },
    ]
  }

  render() {
    const { showMessage: Message, showBody: Body, id } = this.props
    const { initValues基本信息, changedValues基本信息 } = this.state
    if (!initValues基本信息) return <Message text={'请稍等 ...'} />

    return <Body data={this} maxWidth="600"
      controls={
        [
          { _button: '保存', icon: 'save', handler: this.handlerConfirm, disabled: !this.canSave() },
          { _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0 },
          { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
        ]}
      fieldsets={
        [
          { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
        ]}
    />
  }
}

export default connect()(TeamDiv)